import { render } from "./WalletLink.vue?vue&type=template&id=0ce36832"
const script = {}

import exportComponent from "/Users/abner.huang/plutolab/nft-pluto-hiphop-1/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__